/**
 * 区分 activityDirectionType（activities.activity_direction_type）
 * 出典：要件書 5.2
 */
export const ACTIVITY_DIRECTION_TYPE_VALUES = ['inbound', 'outbound'] as const;

export type ActivityDirectionType = (typeof ACTIVITY_DIRECTION_TYPE_VALUES)[number];

export const ACTIVITY_DIRECTION_TYPE_LABELS: Readonly<Record<ActivityDirectionType, string>> = {
  inbound: '受信',
  outbound: '送信',
};
